import { enableTrackingAndAnalytics } from '../consentManager/tagHelpers';
import { TrackingEvent } from './types';

const enableTagManager = enableTrackingAndAnalytics();
let initialized = false;

const tagManagerId = 'GTM-5WTBR3Z';
const trackingIdGA4 = 'G-TDQQKJDD8S';

const sendDirectlyToTagManager = false;
const trackingID = sendDirectlyToTagManager ? tagManagerId : trackingIdGA4;

function addConsentModeSettings(): void {
  const script = document.createElement('script');
  script.dataset.cookieconsent = 'ignore';
  script.textContent = `window.dataLayer = window.dataLayer || [];
function gtag() {
  dataLayer.push(arguments);
}
gtag("consent", "default", {
  ad_personalization: "denied",
  ad_storage: "denied",
  ad_user_data: "denied",
  analytics_storage: "denied",
  functionality_storage: "denied",
  personalization_storage: "denied",
  security_storage: "granted",
  wait_for_update: 500,
});
gtag("set", "ads_data_redaction", true);
gtag("set", "url_passthrough", true);`;

  const { head } = document;
  head.append(script);
}

function addTagManager(): void {
  const { head } = document;
  const tagManagerScript = document.createElement('script');
  tagManagerScript.textContent = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${tagManagerId}');`;
  head.append(tagManagerScript);
}

function initialize(): void {
  if (!enableTagManager || typeof document === 'undefined') {
    return;
  }

  initialized = true;

  addConsentModeSettings();
  addTagManager();
}

function isInitialized(): boolean {
  return !!initialized;
}

function getGTag(): ((...args: unknown[]) => void) | null {
  if (typeof window === 'undefined' || !initialized) {
    return null;
  }
  const { gtag } = window;
  if (!gtag) {
    console.error('gtag not yet initialized');
    return null;
  }
  return gtag;
}

function event(eventName: string, properties: object): void {
  const gTag = getGTag();
  if (!gTag) {
    return;
  }
  gTag('event', eventName, { send_to: trackingID, ...properties });
}

function trackEvent(trackingEvent: TrackingEvent): void {
  event(trackingEvent.event, trackingEvent.parameters);
}

export default { initialize, isInitialized, event, trackEvent };
